import { render, staticRenderFns } from "./CallItem.vue?vue&type=template&id=50643ffa"
import script from "./CallItem.vue?vue&type=script&lang=js"
export * from "./CallItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports